import { Report } from '@cims-online/shared'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { ReportFilenamesContext } from './types'
import { useReportFilenamesQuery } from 'schema'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } = createStrictContext<ReportFilenamesContext>(
  'ReportFilenamesContext'
)

export const useReportFilenamesContext = useContextFn

const ReportFilenamesProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const { data, loading, refetch } = useReportFilenamesQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })

  return (
    <Provider
      value={{
        reportFilenames: Report.clientReports.map((report) => ({
          ...report,
          templateItems:
            data?.reportFilenames?.records?.find(
              ({ reportId }) => reportId === report.id
            )?.templateItems ?? null,
        })),
        refetch,
        loading,
      }}
    >
      {children}
    </Provider>
  )
}

export default ReportFilenamesProvider
